"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mui = require("tss-react/mui");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Popover = _interopRequireDefault(require("@mui/material/Popover"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _Menu = require("../Menu");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    root: {
      zIndex: theme.zIndex.tooltip
    },
    paper: {
      boxShadow: theme.customShadows.small,
      borderRadius: 5
    }
  };
});

/** Used internally by the ContextMenu component */
var DesktopContextMenu = function DesktopContextMenu(_ref) {
  var anchorOrigin = _ref.anchorOrigin,
    transformOrigin = _ref.transformOrigin,
    anchorRef = _ref.anchorRef,
    open = _ref.open,
    onToggle = _ref.onToggle,
    children = _ref.children;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    anchorEl: anchorRef.current,
    open: open,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    onClose: onToggle
  }, /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    className: classes.paper
  }, /*#__PURE__*/_react["default"].createElement(_Menu.MenuList, {
    autoFocusItem: open
  }, children)));
};
DesktopContextMenu.propTypes = {
  anchorOrigin: _propTypes["default"].oneOf({
    horizontal: 'center' || 'left' || 'right',
    vertical: 'bottom' || 'center' || 'top'
  }).isRequired,
  transformOrigin: _propTypes["default"].oneOf({
    horizontal: 'center' || 'left' || 'right',
    vertical: 'bottom' || 'center' || 'top'
  }).isRequired,
  onToggle: _propTypes["default"].func,
  anchorRef: _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Element)
  }),
  open: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired
};
DesktopContextMenu.defaultProps = {
  open: false,
  onToggle: undefined,
  anchorRef: undefined
};
var _default = DesktopContextMenu;
exports["default"] = _default;